import { jsxs as c, jsx as r } from "react/jsx-runtime";
function t() {
  return /* @__PURE__ */ c("svg", { viewBox: "0 0 24 24", children: [
    /* @__PURE__ */ r("path", { d: "M3.65,13.26l-.9-.42A10.09,10.09,0,0,1,12,7.05v1A9.12,9.12,0,0,0,3.65,13.26Z" }),
    /* @__PURE__ */ r("path", { d: "M20.35,13.26A9.12,9.12,0,0,0,12,8.05v-1a10.09,10.09,0,0,1,9.25,5.79Z" }),
    /* @__PURE__ */ r("circle", { cx: "11.8", cy: "12.85", r: "3.6" })
  ] });
}
export {
  t as default
};
